import { Box } from '@mui/material';
import { imageSetForPNG } from '../../utils/imageset';

function ThirdPage() {
  return (
    <Box
      id="third-page"
      sx={{
        height: '100vh',
        width: '100%',
        position: 'relative',
        backgroundImage: imageSetForPNG('/images/third_background.png'),
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      {/* Content for the third page goes here */}
    </Box>
  );
}

export default ThirdPage; 